import config from '../../../config';

export const FROM_FAX_NUMBER = config.ENV === 'PROD'
                                ? '601-605-7955'
                                : '662-346-7732';

export const NEW_STATUS_RECEIVED_FAX = 'new';
export const PROCESSING_STATUS_RECEIVED_FAX = 'processing';
export const PROCESSED_STATUS_RECEIVED_FAX = 'processed';
export const REVIEWED_STATUS_RECEIVED_FAX = 'reviewed';

export const RECEIVED_FAX_PROCESSING_STATUSES = [
    NEW_STATUS_RECEIVED_FAX,
    PROCESSING_STATUS_RECEIVED_FAX
];
